import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";
import Saudi_Riyal_Symbol from "../../../images/Saudi_Riyal_Symbol-1.png";
import { useTranslation } from "react-i18next";
import { Col, Card, Table, Badge, ProgressBar } from "react-bootstrap";
import ProjectAchievementChart from "./ProjectAchievementChart";
import ProjectTimelineChart from "./ProjectTimelineChart";

const Home = () => {
  const { changeBackground, background } = useContext(ThemeContext);

  const [projectsCount, setProjectsCount] = useState({
    advanced: 0,
    late: 0,
    on_track: 0,
  });
  const [projectAverage, setProjectAverage] = useState({
    average_total_actual_project_price: 0,
  });

  const [rejectCompletionRate, setRejectCompletionRate] = useState({});

  const [projectAverageAmount, setProjectAverageAmount] = useState({});

  const [rankingData, setRankingData] = useState([]);
  const [topProjects, setTopProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjectsCount = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/track_count",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectsCount({
        advanced: data.advanced || 0,
        late: data.late || 0,
        on_track: data.on_track || 0,
      });
    } catch (err) {
      console.error("خطأ:", err);
      setProjectsCount({
        advanced: 0,
        late: 0,
        on_track: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAverage = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/average_actual_price",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectAverage({
        average_total_actual_project_price:
          data.average_total_actual_project_price || 0,
      });
    } catch (err) {
      console.error("خطأ:", err);
      setProjectAverage({
        average_total_actual_project_price: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectCompletionReate = async () => {
    try {
      const res = await fetch(
        " https://promaster.areez.co/api/projects/average_achievement",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setRejectCompletionRate(data);
    } catch (err) {
      console.error("خطأ:", err);
      setRejectCompletionRate({});
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAverageAmount = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/average_amount",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectAverageAmount(data);
    } catch (err) {
      console.error("خطأ:", err);
      setProjectAverageAmount({});
    } finally {
      setLoading(false);
    }
  };

  const fetchTopProjects = async () => {
    try {
      const res = await fetch("https://promaster.areez.co/api/projects/top10", 
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      setTopProjects(data);
    } catch (err) {
      console.error("فشل في تحميل المشاريع:", err);
      setTopProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchRanking = async () => {
    try {
      const res = await fetch(
        "https://plo.areez.co/api/plo/university/ranking"
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setRankingData(data.data);
    } catch (err) {
      console.error("خطأ:", err);
      setRankingData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectsCount();
    fetchProjectAverage();
    fetchProjectCompletionReate();
    fetchProjectAverageAmount();
    fetchTopProjects();
    fetchRanking();
    changeBackground({ value: "light", label: "Light" });
  }, []);

  // const handleCompare = (program_id) => {
  //   let id = program_id;
  //   window.location.href = `/programs/compare/${id}`;
  // };

  const getTrackColor = (track) => {
    switch (track) {
      case "advanced":
        return "success";
      case "on_track":
        return "info";
      case "late":
        return "danger";
      default:
        return "secondary";
    }
  };

  const handleCompare = (row) => {
    const id = row.project_id || row.id || row.program_id;
    window.location.href = `/projects/detailes/${id}`;
  };

  const {t} = useTranslation();
  return (
    <div className="row">
      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-success">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-caret-up"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">{t("Advanced Projects Count")}</p>
                  <h3 className="text-white">{projectsCount.advanced}</h3>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-secondary">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-exclamation"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">{t("On Track Projects Count")}</p>
                  <h3 className="text-white">{projectsCount.on_track}</h3>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-danger">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-caret-down"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">{t("Delayed Projects Count")}</p>
                  <h3 className="text-white">{projectsCount.late}</h3>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-muted">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-ravelry text-dark"></i>
                </span>
                <div className="media-body text-dark">
                  <p className="mb-1">{t("Average Completed Project Value")}</p>
                  <h3 className="text-dark">{projectAverage.average_total_actual_project_price}</h3>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-primary">
            <div className="card-body p-4">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-circle-o-notch text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">{t("Average Completion Rate and Project Count")}</p>
                  <h3 className="text-white">{rejectCompletionRate.project_count}</h3>
                  <ProgressBar
                    now={rejectCompletionRate.average_achievement_percentage}
                    variant="white"
                    style={{ height: "6px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-4 col-lg-6 col-sm-6">
        <Link style={{ textDecoration: "none" }}>
          <div className="widget-stat card bg-info text-center">
            <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-white">
              <i className="fa fa-bar-chart fa-2x mb-3"></i>

              <h2 className="mb-2" style={{ fontSize: "36px", fontWeight: "bold" }}>
                {Number(projectAverageAmount.average_project_amount).toLocaleString()}
                <span style={{ fontSize: "20px", marginRight: "4px" }}>
                  <img src={Saudi_Riyal_Symbol} width={30} style={{ marginTop: "-20px" }} />
                </span>
              </h2>

              <p className="mb-1" style={{ fontSize: "14px" }}>
                {t("Project Count")}: <strong>{projectAverageAmount.project_count}</strong>
              </p>
              <p className="mb-0" style={{ fontSize: "13px", opacity: 0.9 }}>
                {t("Average Project Value")}
              </p>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-xl-6 col-lg-12 col-sm-12">
        <div className="card p-3">
          <h5 className="mb-3">{t("Project Achievement Comparison")}</h5>
          <ProjectAchievementChart />
        </div>
      </div>

      <div className="col-xl-6 col-lg-12 col-sm-12">
        <div className="card p-3">
          <h5 className="mb-3">{t("Project Timeline Achievement Comparison")}</h5>
          <ProjectTimelineChart />
        </div>
      </div>

      <Col lg={12}>
        <Card>
          <Card.Header>
            <Card.Title>{t("Top 10 Projects by Achievement")}</Card.Title>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <p className="text-center">{t("Loading...")}</p>
            ) : topProjects.length === 0 ? (
              <p className="text-center">{t("No data available.")}</p>
            ) : (
              <Table responsive hover className="header-border verticle-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t("Project Code")}</th>
                    <th>{t("Project Name")}</th>
                    <th>{t("Elapsed Period")}</th>
                    <th>{t("Completion Rate")}</th>
                    <th>{t("Track")}</th>
                    <th>{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {topProjects.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.name}</td>
                      <td>{item.elapsed_period_percentage.toFixed(2)}%</td>
                      <td>
                        <ProgressBar
                          now={item.achievement_percentage_per_project}
                          variant="primary"
                          style={{ height: "6px" }}
                        />
                        <Badge variant="primary" className="ml-2">
                          {item.achievement_percentage_per_project.toFixed(2)}%
                        </Badge>
                      </td>
                      <td>
                        <Badge variant={getTrackColor(item.project_track)}>
                          {item.project_track === "advanced"
                            ? t("Advanced")
                            : item.project_track === "late"
                            ? t("Delayed")
                            : t("On Track")}
                        </Badge>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleCompare(item)}
                        >
                          {t("Details")}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
};

export default Home;
